module.exports = __webpack_public_path__ + "static/media/django.8c0e0365.svg";